import { render, staticRenderFns } from "./NewUsedVehicleComponent.vue?vue&type=template&id=19f7a1b8"
import script from "./NewUsedVehicleComponent.vue?vue&type=script&lang=ts"
export * from "./NewUsedVehicleComponent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports